import { render, staticRenderFns } from "./KlientiFiltersBar.vue?vue&type=template&id=75802916&scoped=true&"
import script from "./KlientiFiltersBar.vue?vue&type=script&lang=js&"
export * from "./KlientiFiltersBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75802916",
  null
  
)

export default component.exports